// The public landing (ADR-0060) — the one page an anonymous visitor (no Session) sees
// on `/` (and on any route except `/claim`, which stays reachable so a newcomer with a
// code can proceed). Under the app-level-auth model nothing is gated at the edge, so
// this page is truly public.
//
// It is just the wordmark + the hero CTA "Claim your camera" (signup = a first Claim),
// an SPA nav to `/claim`. "Log in" lives in the header (top-right), not here — Google is
// deliberately quiet.

export interface LandingProps {
  /** SPA-navigate to the claim flow (the hero CTA). */
  onClaim: () => void;
}

export function Landing({ onClaim }: LandingProps): React.JSX.Element {
  return (
    <div className="landing" data-testid="landing">
      <h1 className="landing__title">
        <b>PIX</b>IE
      </h1>
      <div className="landing__actions">
        <button
          type="button"
          className="btn btn--primary landing__claim"
          onClick={onClaim}
          data-testid="landing-claim"
        >
          Claim your camera
        </button>
      </div>
    </div>
  );
}
